/* Lichtgrün — add to cart -> open Dawn's native cart drawer.
   Powers: product-card quick-add (+), the PDP add form, and the cart-drawer upsell (+).
   Uses Dawn cart-drawer.renderContents() (Section Rendering API) so the drawer updates + opens natively. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }

  function sectionIds(cart) {
    try { return cart.getSectionsToRender().map(function (s) { return s.id; }); }
    catch (e) { return ['cart-drawer', 'cart-icon-bubble']; }
  }

  function addToCart(id, qty, onDone, onErr) {
    var cart = drawer();
    var body = { id: id, quantity: qty || 1 };
    if (cart) { body.sections = sectionIds(cart); body.sections_url = window.location.pathname; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { if (onErr) onErr(res.data); return; }
        if (cart && res.data.sections) { cart.renderContents(res.data); cart.classList.remove('is-empty'); }
        else if (cart) { cart.open(); }
        if (onDone) onDone(res.data);
      })
      .catch(function (err) { if (onErr) onErr(err); });
  }
  window.lgAddToCart = addToCart;

  /* Bestaetigungs-Flash im Button: kurz "Im Warenkorb" + Haken, dann zurueck. Rein kosmetisch, laeuft NACH erfolgreichem Add. */
  var LG_CHECK = '<svg class="lg-added__ck" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function flashAdded(btn, label) {
    if (!btn) return;
    if (btn._lgAddedT) clearTimeout(btn._lgAddedT);
    if (btn.getAttribute('data-lg-orig') === null) btn.setAttribute('data-lg-orig', btn.innerHTML);
    btn.classList.add('is-added');
    if (label) btn.innerHTML = LG_CHECK + '<span>' + label + '</span>';
    btn._lgAddedT = setTimeout(function () {
      btn.classList.remove('is-added');
      var o = btn.getAttribute('data-lg-orig');
      if (o !== null) { btn.innerHTML = o; btn.removeAttribute('data-lg-orig'); }
      btn._lgAddedT = null;
    }, 1600);
  }
  window.lgFlashAdded = flashAdded;

  document.addEventListener('click', function (e) {
    /* product-card circle quick-add */
    var qa = e.target.closest('.lg-card__qabtn');
    if (qa) {
      e.preventDefault();
      if (qa.classList.contains('is-loading')) return;
      var vid = qa.getAttribute('data-variant-id');
      if (!vid) return;
      qa.classList.add('is-loading');
      addToCart(vid, 1,
        function () { qa.classList.remove('is-loading'); qa.classList.add('is-added'); setTimeout(function () { qa.classList.remove('is-added'); }, 1400); },
        function () { qa.classList.remove('is-loading'); qa.classList.add('is-error'); setTimeout(function () { qa.classList.remove('is-error'); }, 1600); }
      );
      return;
    }
    /* cart-drawer upsell */
    var up = e.target.closest('[data-lg-add]');
    if (up) {
      e.preventDefault();
      if (up.classList.contains('is-loading')) return;
      var uid = up.getAttribute('data-lg-add');
      if (!uid) return;
      up.classList.add('is-loading');
      addToCart(uid, 1, function () { up.classList.remove('is-loading'); flashAdded(up); }, function () { up.classList.remove('is-loading'); });
      return;
    }
  });

  /* PDP add form -> open drawer instead of full-page redirect (graceful fallback to native submit on error) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.lg-pdp__form');
    if (!form) return;
    e.preventDefault();
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var id = idEl ? idEl.value : null;
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    if (!id) { form.submit(); return; }
    var addBtn = form.querySelector('[name="add"]');
    if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.classList.add('is-loading'); }
    addToCart(id, qty,
      function () { if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); flashAdded(addBtn, 'Im Warenkorb'); } },
      function () { if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); } form.submit(); }
    );
  });
})();
